'use client';

import { c as _c } from "react/compiler-runtime";
import type { UseNegociacaoSelfReturn } from '../hooks';
import { useNegociacaoSelf, usePagamentoSelfPolling, useSelfStepUrl } from '../hooks';
import { CriandoAgenteModal } from './CriandoAgenteModal';
import { ErroModal } from './ErroModal';
import { ErroPagamentoModal } from './ErroPagamentoModal';
import { LandingScreen } from './LandingScreen';
import { ObjetivoScreen } from './ObjetivoScreen';
import { PagamentoScreen } from './PagamentoScreen';
import { ParametrosScreen } from './ParametrosScreen';
import { PerfilScreen } from './PerfilScreen';
import { RevisaoScreen } from './RevisaoScreen';
import { SuccessScreen } from './SuccessScreen';
import { TermsScreen } from './TermsScreen';
import { WaitingPaymentScreen } from './WaitingPaymentScreen';
const renderScreen = (vm: UseNegociacaoSelfReturn, voltarNoHistorico: () => void) => {
  switch (vm.step) {
    case 'objetivo':
      return <ObjetivoScreen vm={vm} />;
    case 'perfil':
      return <PerfilScreen vm={vm} />;
    case 'parametros':
      return <ParametrosScreen vm={vm} />;
    case 'revisao':
      return <RevisaoScreen vm={vm} />;
    case 'pagamento':
    case 'errorPayment':
      return <PagamentoScreen vm={vm} />;
    case 'terms':
      return <TermsScreen onVoltar={voltarNoHistorico} />;
    case 'waitingPayment':
      return <WaitingPaymentScreen vm={vm} />;
    case 'success':
      return <SuccessScreen vm={vm} />;
    case 'landing':
    default:
      return <LandingScreen vm={vm} />;
  }
};
export const NegociacaoSelfWizard = () => {
  const $ = _c(28);
  const vm = useNegociacaoSelf();
  const voltarNoHistorico = useSelfStepUrl(vm.step, vm.goTo);
  usePagamentoSelfPolling();
  let t0;
  if ($[0] !== vm || $[1] !== voltarNoHistorico) {
    t0 = renderScreen(vm, voltarNoHistorico);
    $[0] = vm;
    $[1] = voltarNoHistorico;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== vm.cancelarCriacaoAgente || $[4] !== vm.criandoAgente) {
    t1 = vm.criandoAgente && <CriandoAgenteModal onCancelar={vm.cancelarCriacaoAgente} />;
    $[3] = vm.cancelarCriacaoAgente;
    $[4] = vm.criandoAgente;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== vm.objetivosError || $[7] !== vm.recarregarObjetivos) {
    t2 = vm.objetivosError && <ErroModal titulo={"N\xE3o foi poss\xEDvel carregar os objetivos"} descricao={"Algo deu errado ao buscar as op\xE7\xF5es. Verifique sua conex\xE3o e tente novamente."} onTentarNovamente={vm.recarregarObjetivos} />;
    $[6] = vm.objetivosError;
    $[7] = vm.recarregarObjetivos;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== vm.contextoError || $[10] !== vm.tentarBuscaNovamente) {
    t3 = vm.contextoError && <ErroModal titulo={"N\xE3o foi poss\xEDvel salvar seus dados"} descricao={"Algo deu errado ao registrar suas informa\xE7\xF5es. Nada foi perdido \u2014 tente novamente."} onTentarNovamente={vm.tentarBuscaNovamente} />;
    $[9] = vm.contextoError;
    $[10] = vm.tentarBuscaNovamente;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== vm.camposError || $[13] !== vm.recarregarCampos) {
    t4 = vm.camposError && <ErroModal titulo={"N\xE3o foi poss\xEDvel carregar os par\xE2metros"} descricao={"Algo deu errado ao buscar os par\xE2metros do objetivo. Tente novamente."} onTentarNovamente={vm.recarregarCampos} />;
    $[12] = vm.camposError;
    $[13] = vm.recarregarCampos;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== vm.criarAgente || $[16] !== vm.criarAgenteError) {
    t5 = vm.criarAgenteError && <ErroModal titulo={"N\xE3o foi poss\xEDvel testar seu agente"} descricao={"Algo deu errado ao preparar sua Lexi. Suas configura\xE7\xF5es est\xE3o preservadas \u2014 tente novamente."} onTentarNovamente={vm.criarAgente} />;
    $[15] = vm.criarAgente;
    $[16] = vm.criarAgenteError;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== vm) {
    t6 = vm.step === "errorPayment" && <ErroPagamentoModal descricao={vm.pagamentoError} onTentarNovamente={vm.tentarPagamentoNovamente} onTrocarMetodo={() => vm.goTo("pagamento")} />;
    $[18] = vm;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t0 || $[21] !== t1 || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
    t7 = <>{t0}{t1}{t2}{t3}{t4}{t5}{t6}</>;
    $[20] = t0;
    $[21] = t1;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
};